import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home')
  },
  {
    path: '/category/:slug',
    name: 'Category',
    component: () => import('@/views/Category')
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('@/views/Search')
  },
  {
    path: '/terms',
    name: 'Terms',
    component: () => import('@/views/Terms')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/Contact')
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('@/views/Privacy')
  },
  {
    path: '/favorites',
    name: 'Favorites',
    component: () => import('@/views/Favorites')
  },
  {
    path: '/tool/:slug',
    name: 'ToolDetail',
    component: () => import('@/views/ToolDetail')
  },
]

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes
})
